<template>
  <div>
    <div v-if="guessStatus">
      <div v-if="guessStatus === 'guessing'">Checking for QR code</div>
      <div v-else-if="guessStatus === 'found'"></div>
      <div v-else-if="guessStatus === 'not_found'">QR code not found (it's ok, just type the link yourself)</div>
    </div>
    <div v-if="guessUrl">
      <div v-if="guessStatus === 'not_url'">QR code result: {{guessUrl}}</div>
      <div v-else>
        <div>QR code result: <a :href="guessUrl" target="_blank">{{ guessUrl }}</a></div>
        <div><button @click="useGuess">Use found QR code</button></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    guessStatus: String,
    guessUrl: String,
  },
  methods: {
    useGuess() {
      this.$emit('useGuess')
    },
  }
}
</script>
